<div class="card">
    <div class="card-header card-header-squirrel">
        <h4>{{this.translate.data['TOOLTIPCLONEPROJECT'] | translate}}</h4>
    </div>
    <div class="card-body">
        <form [formGroup]="cloneProjectForm">
            <div class="row">
                <div class="col-md-12">
                    <mat-form-field class="example-full-width">
                        <input matInput placeholder="{{this.translate.data['INPUTPROJECTNAME'] | translate}}" formControlName="name" required>
                                <button mat-button  matSuffix mat-icon-button (click)="createCloneProject()"> 
                                    <mat-icon>add</mat-icon>
                                </button>
                    </mat-form-field>
                </div>
            </div>            
        </form>
    </div>    
</div>

<!-- <h1 mat-dialog-title>Clone Project</h1>
<div mat-dialog-content>
    <form [formGroup]="cloneProjectForm">
        <mat-form-field class="form-element">
            <input matInput placeholder="Enter Project Name" formControlName="name" required>
                    <button mat-button color="primary"  matSuffix mat-icon-button (click)="createCloneProject()"> 
                        <mat-icon>add</mat-icon>
                    </button>
        </mat-form-field>
    </form>
</div> -->